import React from "react";
import { Box, Stack, Typography, Divider, CircularProgress } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { useHistory } from "react-router-dom";
import { designWeights } from "services/constants/designTokens";
import { dashboard } from "../dashboardStyles";

// Pending Requests KPI tile. The count comes from useMyPendingRequests (shared
// with the My Requests Summary card) so the tile total always equals the sum of
// the per-type rows in that summary.
export const PendingRequestsKpi = ({ total, loading }) => {
  const history = useHistory();

  return (
    <Box sx={dashboard.cardSx}>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.5 }}>
        <Box sx={dashboard.iconWrap(dashboard.colors.amber)}>
          <HourglassEmptyIcon fontSize="small" />
        </Box>
        <Typography fontWeight={designWeights.semibold} sx={{ color: dashboard.colors.subText }}>
          Pending Requests
        </Typography>
      </Stack>
      {loading ? (
        <CircularProgress size={20} />
      ) : (
        <>
          <Typography variant="h5" fontWeight={designWeights.heading} sx={{ color: dashboard.colors.text }}>
            {total}
          </Typography>
          <Typography variant="caption" sx={{ color: dashboard.colors.subText }}>
            {total === 1 ? "Request" : "Requests"}
          </Typography>
        </>
      )}
      <Divider sx={{ my: 1.5 }} />
      <Typography
        sx={dashboard.linkSx}
        onClick={() => history.push("/admin/myzone/apply?view=leave")}
      >
        View My Requests →
      </Typography>
    </Box>
  );
};
